import {
  ADD_RESPONSIBLE_PARTIES_REQUEST,
  ADD_RESPONSIBLE_PARTIES_SUCCESS,
  ADD_RESPONSIBLE_PARTIES_ERROR,
  EDIT_RESPONSIBLE_PARTIES_REQUEST,
  EDIT_RESPONSIBLE_PARTIES_SUCCESS,
  EDIT_RESPONSIBLE_PARTIES_ERROR,
  DELETE_RESPONSIBLE_PARTIES_REQUEST,
  DELETE_RESPONSIBLE_PARTIES_SUCCESS,
  DELETE_RESPONSIBLE_PARTIES_ERROR,
  LIST_RESPONSIBLE_PARTIES_REQUEST,
  LIST_RESPONSIBLE_PARTIES_SUCCESS,
  LIST_RESPONSIBLE_PARTIES_ERROR,
} from '../../actions';

export const listResponsiblePartiesRequest = (studentId) => ({
  type: LIST_RESPONSIBLE_PARTIES_REQUEST,
  payload: { studentId },
});
export const listResponsiblePartiesSuccess = (responsibleParties) => ({
  type: LIST_RESPONSIBLE_PARTIES_SUCCESS,
  payload: responsibleParties,
});
export const listResponsiblePartiesError = (message) => ({
  type: LIST_RESPONSIBLE_PARTIES_ERROR,
  payload: { message },
});

export const addResponsiblePartiesRequest = (responsibleParties) => ({
  type: ADD_RESPONSIBLE_PARTIES_REQUEST,
  payload: { responsibleParties },
});
export const addResponsiblePartiesSuccess = (responsibleParties) => ({
  type: ADD_RESPONSIBLE_PARTIES_SUCCESS,
  payload: responsibleParties,
});
export const addResponsiblePartiesError = (message) => ({
  type: ADD_RESPONSIBLE_PARTIES_ERROR,
  payload: { message },
});

export const editResponsiblePartiesRequest = (responsibleParties) => ({
  type: EDIT_RESPONSIBLE_PARTIES_REQUEST,
  payload: { responsibleParties },
});
export const editResponsiblePartiesSuccess = (responsibleParties) => ({
  type: EDIT_RESPONSIBLE_PARTIES_SUCCESS,
  payload: { responsibleParties },
});
export const editResponsiblePartiesError = (message) => ({
  type: EDIT_RESPONSIBLE_PARTIES_ERROR,
  payload: { message },
});

export const deleteResponsiblePartiesRequest = (id, studentId) => ({
  type: DELETE_RESPONSIBLE_PARTIES_REQUEST,
  payload: { id, studentId },
});
export const deleteResponsiblePartiesSuccess = (id) => ({
  type: DELETE_RESPONSIBLE_PARTIES_SUCCESS,
  payload: { id },
});
export const deleteResponsiblePartiesError = (message) => ({
  type: DELETE_RESPONSIBLE_PARTIES_ERROR,
  payload: { message },
});
